module.exports = __webpack_public_path__ + "img/welcome-loader.6e7fcc27.png";